export { default } from './MapDescription';
